import type { ConsumablesMatrixData } from "@product-details/containers/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.types";

export const findPackagingFormat = (consumablesMatrixData: ConsumablesMatrixData, packagingFormaId: string) => {
  return consumablesMatrixData.packagingFormats.find((format) => format.id === packagingFormaId);
};
